import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  async toggle() {
    if (this.popover) {
      this.popover.remove()
      this.popover = null
      return
    }

    const response = await fetch(this.urlValue, {
      headers: { "Accept": "application/json" }
    })

    if (!response.ok) return

    const data = await response.json()

    this.popover = document.createElement("div")
    this.popover.className = "absolute bottom-full mb-2 right-0 bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-stone-200 dark:border-slate-600 p-3 z-50 min-w-64 max-w-80 max-h-64 overflow-y-auto"

    let html = '<div class="text-xs font-medium text-stone-500 dark:text-slate-400 mb-2">Edit history</div>'

    // Current version
    html += `<div class="mb-2 pb-2 border-b border-stone-100 dark:border-slate-700">
      <div class="text-xs text-teal-600 dark:text-teal-400 font-medium mb-0.5">Current &middot; ${data.current_at}</div>
      <div class="text-sm text-stone-700 dark:text-slate-200 whitespace-pre-wrap">${this.escapeHtml(data.current_content)}</div>
    </div>`

    // Previous versions
    data.edits.forEach((edit, i) => {
      const isLast = i === data.edits.length - 1
      html += `<div class="${isLast ? '' : 'mb-2 pb-2 border-b border-stone-100 dark:border-slate-700'}">
        <div class="text-xs text-stone-400 dark:text-slate-500 mb-0.5">${edit.edited_by} &middot; ${edit.edited_at}</div>
        <div class="text-sm text-stone-500 dark:text-slate-400 whitespace-pre-wrap">${this.escapeHtml(edit.original_content)}</div>
      </div>`
    })

    this.popover.innerHTML = html
    this.element.style.position = "relative"
    this.element.appendChild(this.popover)

    this._outsideClick = (e) => {
      if (!this.element.contains(e.target)) {
        this.popover?.remove()
        this.popover = null
        document.removeEventListener("click", this._outsideClick)
      }
    }
    setTimeout(() => document.addEventListener("click", this._outsideClick), 0)
  }

  escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }

  disconnect() {
    this.popover?.remove()
    document.removeEventListener("click", this._outsideClick)
  }
}
